import { useFormik } from 'formik';
import React from 'react';
import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import swal from 'sweetalert';
import {
  createSettings,
  getAllProviderCall,
  getAllProviderSMS,
  getSettings,
  updateSettings,
} from '../../api-services';
import Select from 'react-select';
import { useEffect } from 'react';
import BarLoader from 'react-bar-loader';
import clsx from 'clsx';
const initialState = {
  set_lcr: false,
  lcr_value: [],
  global_call_providers: '',
  global_sms_providers: '',
};

const Settings = () => {
  const queryClient = useQueryClient();
  const [initialValues, setInitialValues] = useState(initialState);
  const [prevSelectedArr, setPrevSelectedArr] = useState([]);

  const { data: AllProvidersCall, isLoading: isLoadingAllCallProvider } =
    useQuery('getAllProviderCall', getAllProviderCall, {
      select: (data) => data?.data?.data,
    });
  const { data: AllProvidersSMS, isLoading: isLoadingAllSMSProvider } =
    useQuery('getAllProviderSMS', getAllProviderSMS, {
      select: (data) => data?.data?.data,
    });

  const { mutateAsync: mutateAsyncCreateSettings, isLoading: isLoadingCreate } =
    useMutation('createSettings', createSettings, {
      select: (data) => data?.data?.data,
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
          type: 'success',
        }).then(() => {
          queryClient.invalidateQueries('getSettings');
        });
      },
      onError: (error) => {
        swal({
          type: 'danger',
          text: error?.response?.data?.message,
          icon: 'error',
          timer: 3000,
        });
      },
    });
  const { mutateAsync: mutateAsyncUpdateSettings, isLoading: isLoadingUpdate } =
    useMutation('updateSettings', updateSettings, {
      select: (data) => data?.data?.data,
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
          type: 'success',
        }).then(() => {
          queryClient.invalidateQueries('getSettings');
        });
      },
      onError: (error) => {
        swal({
          type: 'danger',
          text: error?.response?.data?.message,
          icon: 'error',
          timer: 3000,
        });
      },
    });
  const { data: getSettingsData, isLoading } = useQuery(
    'getSettings',
    getSettings,
    {
      select: (data) => data?.data?.data,
    },
  );

  const handleUpdate = async (values) => {
    await mutateAsyncUpdateSettings(values);
  };
  const handleAdd = async (values) => {
    await mutateAsyncCreateSettings(values);
  };

  const handleSubmitForm = (values) => {
    if (getSettingsData && Object.keys(getSettingsData).length > 0) {
      const { set_lcr, lcr_value, ...rest } = values;
      const newLCR =
        lcr_value && lcr_value.length > 0
          ? lcr_value.map((val) => val?.value)
          : [];
      const payload = { lcr_value: newLCR, set_lcr: set_lcr ? 1 : 0, ...rest };
      payload.id = getSettingsData?.id;
      handleUpdate(payload);
    } else {
      const { set_lcr, lcr_value, ...rest } = values;
      const newLCR =
        lcr_value && lcr_value.length > 0
          ? lcr_value.map((val) => val?.value)
          : [];
      const payload = { lcr_value: newLCR, set_lcr: set_lcr ? 1 : 0, ...rest };
      handleAdd(payload);
    }
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const handlePreviousSelected = (valArr) => {
    if (valArr && valArr.length > 0) {
      const mutatedArr =
        AllProvidersCall?.filter((val) =>
          valArr?.includes(val.providerID),
        )?.map((newVal) => ({
          value: newVal?.providerID,
          label: newVal?.name,
        })) ?? [];

      setPrevSelectedArr(mutatedArr);
      formik.setFieldValue('lcr_value', mutatedArr);
    } else {
      setPrevSelectedArr([]);
      formik.setFieldValue('lcr_value', []);
    }
  };

  useEffect(() => {
    if (getSettingsData && Object.keys(getSettingsData).length > 0) {
      const { set_lcr, global_call_providers, global_sms_providers } =
        getSettingsData;
      const payload = {
        set_lcr: set_lcr ? true : false,
        global_call_providers,
        global_sms_providers,
      };
      setInitialValues(payload);
    }
  }, [getSettingsData]);

  useEffect(() => {
    if (getSettingsData?.lcr_value.length > 0) {
      handlePreviousSelected(getSettingsData?.lcr_value);
    }
  }, [AllProvidersCall]);

  useEffect(() => {
    if (!formik.values.set_lcr) {
      formik.setFieldValue('lcr_value', []);
      setPrevSelectedArr([]);
    } else {
      handlePreviousSelected(getSettingsData?.lcr_value);
    }
  }, [formik.values.set_lcr]);

  const handleChaneMultiSelect = (val) => {
    formik.setFieldValue('lcr_value', val);
    setPrevSelectedArr(val);
  };
  const shouldDisabled =
    isLoadingAllCallProvider ||
    isLoadingAllSMSProvider ||
    isLoadingCreate ||
    isLoadingUpdate ||
    isLoading;

  return (
    <form
      onSubmit={formik.handleSubmit}
      className={clsx({
        disable: shouldDisabled,
      })}
    >
      <div className="page_content">
        <section className="lower_section pt-2">
          <div className="setting_sec bg-white w-max-600 mx-auto p-4 mt-3 position-relative">
            {shouldDisabled && (
              <div className="custom-linear-loader-row">
                <div className="custom-linear-loader">
                  <BarLoader color="#000000" height="4px" />
                </div>
              </div>
            )}

            <div className="page_heading page_heading_enhence d-flex justify-content-between align-items-center w-100 bg-white py-2">
              <h3 className="d-flex align-items-center">
                <span className="title">Settings</span>
              </h3>
              <div className="d-flex gutter-1"></div>
            </div>
            <div className="d-flex  align-items-center justify-content-between  mb-3 mt-3 ">
              <label className="text-black font-15">
                Set system / global call provider.
              </label>
              <span className=" w-100 w-max-200">
                <select
                  className="form-control"
                  name="global_call_providers"
                  disabled={isLoading || isLoadingCreate || isLoadingUpdate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.global_call_providers}
                >
                  <option value="">Please select provider</option>
                  {AllProvidersCall &&
                    AllProvidersCall.length > 0 &&
                    AllProvidersCall.map(({ providerID, name }, index) => (
                      <option value={providerID} key={index}>
                        {name}
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="d-flex  align-items-center mb-3 justify-content-between  ">
              <label className="text-black font-15">
                Set system / global SMS provider.
              </label>
              <span className=" w-100 w-max-200">
                <select
                  className="form-control"
                  name="global_sms_providers"
                  disabled={isLoading || isLoadingCreate || isLoadingUpdate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.global_sms_providers}
                >
                  <option value="">Please select provider</option>
                  {AllProvidersSMS &&
                    AllProvidersSMS.length > 0 &&
                    AllProvidersSMS.map(({ providerID, name }, index) => (
                      <option value={providerID} key={index}>
                        {name}
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="d-flex  align-items-center mb-3  justify-content-between ">
              <div className="d-flex align-items-center">
                <input
                  type="checkbox"
                  name="set_lcr"
                  disabled={isLoading || isLoadingCreate || isLoadingUpdate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.set_lcr}
                  checked={formik.values.set_lcr}
                />
                &nbsp;
                <label className="text-black font-15 mt-1 mb-0 m2-1">
                  Set provider or LCR for
                </label>
              </div>

              <span className="custom_input w-100 w-max-200">
                <Select
                  placeholder="Select provider..."
                  options={
                    AllProvidersCall && AllProvidersCall.length > 0
                      ? AllProvidersCall.map(({ providerID, name }, index) => {
                          return { value: providerID, label: name };
                        })
                      : []
                  }
                  isMulti={true}
                  disabled={isLoading || isLoadingCreate || isLoadingUpdate}
                  isDisabled={!formik.values.set_lcr}
                  value={
                    prevSelectedArr && prevSelectedArr.length > 0
                      ? prevSelectedArr
                      : []
                  }
                  name="lcr_value"
                  onChange={(val) => handleChaneMultiSelect(val)}
                />
              </span>
            </div>
            <div className="d-flex  align-items-center mt-4  justify-content-center ">
              <button
                type="submit"
                disabled={isLoading || isLoadingCreate || isLoadingUpdate}
                className="d-flex  justify-content-center  btn btn-primary align-items-center font-600"
              >
                {isLoadingCreate || isLoadingUpdate
                  ? 'Please wait...'
                  : 'Save settings'}
              </button>
            </div>
          </div>
        </section>
      </div>
    </form>
  );
};

export default Settings;
